// ─── SİSTEM KONFİGÜRASYONU ───────────────────────────────────────────────
// Dil ayarı: 'tr' = Türkçe, 'en' = İngilizce
export const LANGUAGE = 'tr';

// Şirket bilgileri
export const COMPANY_NAME = 'Smart Factory';
export const COMPANY_SUBTITLE = 'MES · ERP · MRP';

// Para birimi
export const CURRENCY = '₺';  // İngilizce için '$' veya '€'

// Tarih formatı
export const DATE_LOCALE = 'tr-TR';  // İngilizce için 'en-US'
